import { Link } from "react-router-dom";
import FlowerButton from "@/components/FlowerButton";

export default function Histoire() {
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-14">
      <p className="font-cursive text-2xl text-[#78353A]/70">Notre histoire</p>
      <h1 className="font-cursive text-6xl md:text-7xl text-[#78353A] leading-none">Bienvenue chez MiniMellow</h1>
      <div className="mt-10 space-y-6 text-[#4A3B32]/90 leading-relaxed">
        <p>
          MiniMellow, c'est d'abord une bande d'amis : les MellowFriends. Six petits personnages qui vivent tous à <span className="font-cursive text-2xl text-[#78353A]">MellowCity</span>, chacun avec son univers, ses passions et sa manière de rêver.
        </p>
        <p>
          Autour d'eux, on imagine des <span className="font-cursive text-2xl text-[#78353A]">histoires</span>, des <span className="font-cursive text-2xl text-[#78353A]">carnets de notes</span> à remplir, des stickers — et bientôt bien d'autres douceurs. Des objets pensés pour rêver, dessiner, écrire, partir en aventure.
        </p>
        <p>
          Notre premier trésor, le carnet <span className="font-cursive text-2xl text-[#78353A]">Green Days</span>, suit Bao, Pipo, Milo et toute la bande au jardin : huit thèmes, huit petites histoires, et des pages détachables pour y glisser les tiennes.
        </p>
        <p>
          Notre mission ? Créer un <span className="font-cursive text-2xl text-[#78353A]">univers narratif et immersif</span> dans lequel six personnages hauts en couleur ont chacun leur personnalité, leur histoire et leurs produits, à travers lesquels chacun peut s'identifier.
        </p>
        <p>
          Et parce que nous tenons à la cohérence de cet univers, ce que tu lis dans les livres se prolonge directement dans tes carnets, sur tes stickers et sur tous les autres produits MiniMellow.
        </p>
      </div>
      <div className="mt-10">
        <Link to="/mellowfriends"><FlowerButton>Rencontrer la bande</FlowerButton></Link>
      </div>
    </div>
  );
}
